export enum UserGroup {
    Guest                = 1,
    Admin                = 2,
    RegisteredNdd        = 3,
    CenterAdmin          = 6,
    LogisticsProvider    = 7,
    CenterUser           = 8,
    LogisticsPhlebotUser = 9,
    NkrLabUser           = 10,
    NkdoUser             = 11,
    MicrositeCoachOnly   = 12,
    NkfUser              = 13,
    NkdoMentor           = 14, 
    NkrMentor            = 15,
    Opo                  = 16,
    OpoAdmin             = 17
}